import React from 'react';
import { motion } from 'framer-motion';
import FeatureCard from './FeatureCard';
import { featureData } from './featureData';
import { cardVariants } from './animations';
import { CardHeightProvider } from './context/CardHeightContext';

export default function FeatureGrid() {
  return (
    <CardHeightProvider>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {featureData.map((feature, index) => (
          <motion.div
            key={index}
            custom={index}
            initial="hidden"
            animate="visible"
            variants={cardVariants}
            className="stagger-item"
          >
            <FeatureCard {...feature} index={index} />
          </motion.div>
        ))}
      </div>
    </CardHeightProvider>
  );
}